module.exports = __webpack_public_path__ + "fonts/Lato-Italic.90d8ae9e.woff";